<template>

  <Shell title="Rate Management">

    <router-view></router-view>

  </Shell>  

</template>

<script setup lang="ts">

import Shell from '../Shell.vue'

</script>
